/**
 * Quick-select comparison presets for the Executive Summary dashboard.
 *
 * Each preset derives BOTH the primary range and the comparison range from the
 * latest available data date (see `computePresetRanges`). `custom` is the state
 * the URL falls into once the user hand-edits either range.
 */
export const EXECUTIVE_SUMMARY_PRESETS = [
    'last6vsPrev6',
    'last6YoY',
    'last12vsPrev12',
] as const;

export type ExecutiveSummaryPreset = (typeof EXECUTIVE_SUMMARY_PRESETS)[number];

/** Includes `custom`, the non-preset state stored in the URL. */
export type ExecutiveSummaryPresetOrCustom =
    | ExecutiveSummaryPreset
    | 'custom';

export const DEFAULT_EXECUTIVE_SUMMARY_PRESET: ExecutiveSummaryPreset =
    'last6vsPrev6';

export const EXECUTIVE_SUMMARY_PRESET_LABELS: Record<
    ExecutiveSummaryPreset,
    string
> = {
    last6vsPrev6: 'Last 6 months vs previous 6 months',
    last6YoY: '6 months year-on-year',
    last12vsPrev12: 'Last 12 months vs previous 12 months',
};
